import React from 'react';
import {DownloadIcon} from '@heroicons/react/solid';

/**
 * Zip download card for practice-problem lessons: a "Starter code and
 * solution" heading, the runtime note, and one secondary "Download code"
 * button. The zip link is cross-origin (static.tryexponent.com), so the
 * browser ignores a `download` attribute and names the file from the S3
 * key — a plain href is the intended behavior.
 */
export const CodeDownload = ({url, language}) => (
  <div className="my-6 flex flex-col gap-3 rounded-xl border border-gray-200 bg-white px-5 py-4 shadow-xs sm:flex-row sm:items-center sm:justify-between">
    <div className="min-w-0">
      <div className="font-semibold tracking-tight text-gray-900">Starter code and solution</div>
      <div className="mt-0.5 text-sm text-gray-500">{language}</div>
    </div>
    <a
      href={url}
      className="inline-flex w-full shrink-0 items-center justify-center gap-2 rounded-lg border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 no-underline shadow-sm hover:bg-gray-50 sm:w-auto"
    >
      <DownloadIcon className="h-4 w-4 shrink-0 text-gray-400" />
      Download code
    </a>
  </div>
);

export default CodeDownload;
